define('Store.Item.EntryPoint', [
    'Profile.Model',
    'Store.Item.Stock.Helper',
    'Store.Item.PriceByStore',
    'Store.Item.StockByStore'
], function StoreItemEntryPoint(
    Profile,
    StoreItemStockHelper
) {
    return {
        mountToApp: function mountToApp(application) {
            var pdp = application.getComponent('PDP');
            var layout = application.getComponent('Layout');
            if (pdp) {
                pdp.addToViewContextDefinition('ProductLine.Stock.View', 'unavailabilityMessage', 'string', function fnUnabailabilityMessage() {
                    var item = pdp.getItemInfo();
                    var finalStore = (item && item.store) || Profile.getInstance().get('store');
                    if (!item) {
                        return '';
                    }
                    // eslint-disable-next-line no-underscore-dangle
                    return StoreItemStockHelper._notSoldInStoreMessage(item.item || item, finalStore);
                });
                pdp.addToViewContextDefinition('ProductViews.Price.View', 'showPrice', 'string', function fnShowPrice(context) {
                    var item = (context.model && context.model.item) || context.model;
                    var finalStore = (item && item.store) || Profile.getInstance().get('store');
                    if (!item) {
                        return '';
                    }
                    // eslint-disable-next-line no-underscore-dangle
                    return !StoreItemStockHelper._notSoldInStoreMessage(item, finalStore);
                });
                pdp.addToViewEventsDefinition('ProductLine.Stock.View', 'click [data-action="change-location"]', function fnChangeLocation() {
                    application.openStoreDropdown();
                });
            } else if (layout) {
                /* layout.addToViewContextDefinition('ProductLine.Stock.View', 'unavailabilityMessage', 'string', function fnUnabailabilityMessage(context) {
                    var item = context.model && context.model.item;
                    var finalStore = (item && item.store) || Profile.getInstance().get('store');
                    if (!item) {
                        return '';
                    }
                    // eslint-disable-next-line no-underscore-dangle
                    return StoreItemStockHelper._notSoldInStoreMessage(item, finalStore);
                }); */
                layout.addToViewContextDefinition('ProductViews.Price.View', 'showPrice', 'string', function fnShowPrice(context) {
                    var item = (context.model && context.model.item) || context.model;
                    var finalStore = (item && item.store) || Profile.getInstance().get('store');
                    if (!item) {
                        return '';
                    }
                    // eslint-disable-next-line no-underscore-dangle
                    return !StoreItemStockHelper._notSoldInStoreMessage(item, finalStore);
                });
                layout.addToViewEventsDefinition('ProductLine.Stock.View', 'click [data-action="change-location"]', function fnChangeLocation() {
                    application.openStoreDropdown();
                });
            }
        }
    };
});
